import { useCallback, useMemo, useState } from "react";

const useNormalizerDialog = ({ initialValuesDataSelectorDialog, setInitialValuesDataSelector }) => {
    const [ dataSelectorIndex, setDataSelectorIndex ] = useState();
    const [ initialValues, setInitialValues ] = useState();

    const handleNormalizerDialogClose = useCallback(
        () => {
            setInitialValues(undefined);
            setDataSelectorIndex(undefined);
        },
        []
    );

    const handleNormalizerDialogSubmit = useCallback(
        (values) => {
            const initialValues = { ...initialValuesDataSelectorDialog };
            const newNormalizer = { ...values };

            const options = (
                newNormalizer.options && newNormalizer.options.length ?
                    newNormalizer.options.map((option, index) => ({
                        ...option,
                        position: index
                    }))
                    : []
            );

            newNormalizer.options = JSON.stringify(options);

            if(typeof dataSelectorIndex !== "number") {
                initialValues.normalizers.push(newNormalizer);
            } else {
                initialValues.normalizers[dataSelectorIndex] = newNormalizer;
            }

            initialValues.normalizers = initialValues.normalizers.map((normalizer, index) => ({ ...normalizer  }));

            setInitialValuesDataSelector(initialValues);
            handleNormalizerDialogClose();
        },
        [
            dataSelectorIndex,
            handleNormalizerDialogClose,
            initialValuesDataSelectorDialog,
            setInitialValuesDataSelector
        ]
    );

    const handleOpenNormalizerDialog = useCallback(
        (index) => {
            if(typeof index === "number") {
                const normalizer = initialValuesDataSelectorDialog.normalizers[index];

                setDataSelectorIndex(index);
                setInitialValues(normalizer);
            } else {
                setInitialValues({});
            }
        },
        [ initialValuesDataSelectorDialog ]
    );

    return useMemo(
        () => ({
            isOpenNormalizerDialog: !!initialValues,
            initialValuesNormalizerDialog: initialValues,
            handleNormalizerDialogClose,
            handleNormalizerDialogSubmit,
            handleOpenNormalizerDialog
        }),
        [ handleNormalizerDialogClose, handleNormalizerDialogSubmit, initialValues, handleOpenNormalizerDialog ]
    );
};

export default useNormalizerDialog;
